import { useMutation } from "@tanstack/react-query";
import qcareApi from "./qcareApi";

interface SetSettingsProps {
    data: string[],
    dataCustom?: string[],
    isDefect?: "major" | "minor",
    property: "mainData" | "labels" | "appearance" | "pallgrow"
}

interface SetCustomDefectsProps {
    minor: string[]
    major: string[]
    allMinor: string[]
    allMajor: string[]
}
const setSettings = async (dataCustom:SetSettingsProps) => {
    const { data } = await qcareApi.put("/auth/settings/custom-fields", dataCustom);
    return data
};

const setCustomDefects = async ( dataDefect:SetCustomDefectsProps ) => {
    const { data } = await qcareApi.put("/auth/settings/custom-fields-defects", dataDefect);
    return data
};
// ------------------------- HOOKS -------------------------
export const useSetSettings = () => {
    return useMutation( setSettings )
}

export const useSetCustomDefects = () => {
    return useMutation( setCustomDefects )
}
